@for (text of stringsList; track text; let i = $index) {
  <app-value-edit [(ngModel)]="stringsList[i]"
    (ngModelChange)="onValueEditChange()" [validators]="validators" [valueFullWidth]="true" [delete]="true"
    [editOnClick]="true" (deleted)="onDeleted(i)">
  </app-value-edit>
}
<a href="javascript:void(0)" (click)="onAddPage()">{{addLabel}}</a>